import { useCallback, useState } from 'react';
import type { FormOptions, SubmitFormResults, FormData } from '@/types';
import { submitForm } from '@/services/yepcode';

const useSubmitForm = ({
  hostUrl,
  headers,
  team,
  processId,
  async = false,
}: FormOptions): [
  (data: FormData) => Promise<any>,
  {
    loading: boolean;
    results: SubmitFormResults | undefined;
    error: string | undefined;
    formData: FormData | undefined;
    reset: () => void;
  },
] => {
  const [loading, setLoading] = useState<boolean>(false);
  const [results, setResults] = useState<SubmitFormResults | undefined>(
    undefined
  );
  const [formData, setFormData] = useState<FormData | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);

  const reset = useCallback(() => {
    setLoading(false);
    setResults(undefined);
    setError(undefined);
    setFormData(undefined);
  }, []);

  const submit = useCallback(
    async (formData: FormData) => {
      try {
        setFormData(formData);
        setLoading(true);
        const submitResults = await submitForm({
          hostUrl,
          headers,
          team,
          processId,
          async,
          formData,
        });
        setLoading(false);
        setResults(submitResults);
        return submitResults;
      } catch (error: any) {
        setError(error);
        setLoading(false);
        throw error;
      }
    },
    [hostUrl, headers, team, processId, async]
  );
  return [submit, { loading, results, error, formData, reset }];
};

export default useSubmitForm;
